import React, { useEffect, useState, useRef, useCallback } from 'react';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';

import api from '../../../services/api';
import { useToast } from '../../../hooks/toast';
import getValidationErrors from '../../../utils/getValidationErrors';
import InputSelectMotivos from '../../Inputs/Selects/InputSelectMotivos';
import InputTextArea from '../../Inputs/inputTextArea';

import { Container, Content, ModalContent, FormView } from './styles';

type VendaData = {
  agendamento: boolean;
  campanha: string;
  cupom: { id_desconto: string; type_desc: string; valor: string };
  distance: number;
  duration: number;
  endereco_entrega: EnderecoData;
  formatted_address: string;
  hora_agendada: string;
	cliente: {
		id: string;
		nome: string;
		doc: string;
		phone: string;
		cid: string;
	};
  id_order: number;
  items: ItemData[];
  merchant_id: number;
  mesa: boolean;
  mesa_number: string;
  mesa_token: string;
  order_data: string;
  order_status: string;
	pagamentos: PagamentoData[];
  prev_entrega: string;
  retirar: boolean;
  subTotal: number;
  taxa_entrega: number;
  taxa_service: number;
  tempo_preparo: number;
  tempo_preparo_str: string;
  total: number;
  totalFormatted: string;
  total_merchant: number;
}
type EnderecoData = {
  bai: string;
  cep: string;
  cid: string;
  cidcod: string;
  comp: string;
  distace: {
    distance: { value: number };
    duration: { value: number };
  };
  endereco: string;
  formatted_address: string;
  id: string;
  location: { lat: number; lng: number };
  num: string;
  ponto_ref: string;
  uf: string;
}
type PagamentoData = {
  band_pay: string;
  chave_pay: string;
  currency_pay: string;
  id_pay: number;
  method_pay: string;
  name_pay: string;
  tipchave_pay: string;
  trocoFormatted: string;
  troco_para: number;
  type_pay: string;
  url_pay: string;
}
type ItemData = {
  cod_barras: string;
  complementos: ComplementoData[];
  descricao: string;
  id: string;
  nome: string;
  obs: string;
  promocao: string;
  qtd: number;
  total: number;
  totalFormatted: string;
  url_imagem: string;
  valor: number;
  valorFormatted: string;
}
type ComplementoData = {
  codigo: string;
  descricao: string;
  grupo: string;
  nome: string;
  priceFormatted: string;
  qtd: number;
  qtd_gratis: number;
  qtd_maxima: number;
  valor: number;
}
interface ModalParams {
	id?: string;
	onClose: any;
	venda: VendaData;
}

const ModalVendaCancelar: React.FC<ModalParams> = ({
  onClose = () => {},
  venda,
}) => {
  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();

  const [motivos, setMotivos] = useState([]);

  useEffect(() => {
    api.get('portal/vendas/motivos').then(response => {
      setMotivos(response.data);
    });
  }, []);

  const handleSubmit = useCallback(
    async (data: any) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          motivo: Yup.string().required('Motivo é obrigatório.'),
          just: Yup.string().required('Justificativa é obrigatório.'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const { motivo, just } = data;

        // const usuario = await signIn({
        await api
          .post('portal/vendas/cancel', {
            id_order: venda.id_order,
            motivo,
            just,
          })
          .then(response => {
            addToast({
              type: 'success',
              title: 'Cancelamento',
              description: `${response.data.mensagem}`,
            });

            onClose();
          });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro na autenticação',
          description: 'Ocorreu um erro ao fazer login, cheque as credenciais.',
        });
      }
    },
    [addToast, venda.id_order, onClose],
  );

  return (
    <Container>
      <Content>
        <ModalContent status={venda.order_status}>
          <h1>Cancelamento!</h1>
          <h2>Defina o motivo e a justificativa do cancelamento.</h2>

          <div className="venda">
            <h1>
              {venda.id_order} - <span>{venda.order_status}</span>
            </h1>
            <h1>Data: {venda.order_data}</h1>
            <h1>Valor: {venda.totalFormatted}</h1>
          </div>

          <FormView ref={formRef} onSubmit={handleSubmit}>
            <div className="input">
              <p>
                Motivo <span>(opcional)</span>
              </p>
              <InputSelectMotivos
                name="motivo"
                placeholder="Motivo"
                options={motivos}
                defaultValue={''}
              />
            </div>

            <div className="input">
              <p>
                Justificativa <span>(opcional)</span>
              </p>
              <InputTextArea name="just" placeholder="Justificativa" />
            </div>

            <div className="div-btn">
              <button>Salvar</button>
              <button className="btn-cancel" onClick={onClose}>
                Fechar
              </button>
            </div>
          </FormView>
        </ModalContent>
      </Content>
    </Container>
  );
};

export default ModalVendaCancelar;
